/**
 * Instructors API Module
 *
 * GET /api/Instructors — gibt alle Trainer des Vereins zurück
 */

import { apiClient } from '@/api/client'
import type { InstructorApiDto } from '@/types/api.types'

export const instructorsApi = {
  async getAll(): Promise<InstructorApiDto[]> {
    const response = await apiClient.get<InstructorApiDto[]>('/Instructors')
    return response.data
  },
}
